/* Branding-Basics (Laden + Anwenden der Akzentfarben), beim App-Start gebraucht.
   Eigenes Modul, damit App.js nicht das komplette BrandingModal statisch importiert. */

export const BRANDING_STORAGE_KEY = 'crm_branding';
/* MittelBoost Markengrün — im Light Mode leicht abgedunkelt für Kontrast auf Paper */
export const DEFAULT_LIGHT = '#159c5f';
export const DEFAULT_DARK  = '#22c97e';

export function hexToRgb(hex) {
  const h = hex.replace('#', '');
  return {
    r: parseInt(h.slice(0, 2), 16),
    g: parseInt(h.slice(2, 4), 16),
    b: parseInt(h.slice(4, 6), 16),
  };
}

export function rgbToHex(r, g, b) {
  return '#' + [r, g, b].map(v => Math.max(0, Math.min(255, v)).toString(16).padStart(2, '0')).join('');
}

export function darkenHex(hex, amount = 0.18) {
  const { r, g, b } = hexToRgb(hex);
  return rgbToHex(Math.round(r * (1 - amount)), Math.round(g * (1 - amount)), Math.round(b * (1 - amount)));
}

export function isValidHex(h) { return /^#[0-9a-fA-F]{6}$/.test(h); }

export function loadBranding() {
  try { return JSON.parse(localStorage.getItem(BRANDING_STORAGE_KEY) || 'null') || null; } catch { return null; }
}

/* Alte Blau-Defaults (vor dem MittelBoost-Rebranding) gelten als „nicht gesetzt",
   damit Bestandsnutzer automatisch die Markenfarben bekommen. */
const LEGACY_DEFAULTS = ['#3b82f6', '#60a5fa', '#2c6ef5', '#1d5ce4'];
const pick = (v, fallback) =>
  (v && isValidHex(v) && !LEGACY_DEFAULTS.includes(v.toLowerCase())) ? v : fallback;

export function applyBranding(branding) {
  const light = pick(branding?.accentLight, DEFAULT_LIGHT);
  const dark  = pick(branding?.accentDark,  DEFAULT_DARK);
  const ld = darkenHex(light), dd = darkenHex(dark);
  const { r: lr, g: lg, b: lb } = hexToRgb(light);
  const { r: dr, g: dg, b: db } = hexToRgb(dark);

  let el = document.getElementById('crm-branding-style');
  if (!el) { el = document.createElement('style'); el.id = 'crm-branding-style'; document.head.appendChild(el); }
  el.textContent = `
    :root {
      --accent: ${light};
      --accent-dark: ${ld};
      --accent-bg: rgba(${lr},${lg},${lb},0.07);
      --accent-border: rgba(${lr},${lg},${lb},0.25);
    }
    [data-theme="dark"] {
      --accent: ${dark};
      --accent-dark: ${dd};
      --accent-bg: rgba(${dr},${dg},${db},0.12);
      --accent-border: rgba(${dr},${dg},${db},0.3);
    }
  `;
}
